import { createSelector } from 'reselect'
import getInstancesReduxSelector from '../get-instances'
import { getIdReduxUtil } from '../../utils/get-id'

function getInstanceIdsReduxSelector (domainMapPath, domainListDataPath) {
  return createSelector(
    getInstancesReduxSelector(domainMapPath, domainListDataPath),
    instances => instances.map(getIdReduxUtil)
  )
}

export default getInstanceIdsReduxSelector
